import { Card, NativeSelect, Stack, Typography } from "@altimateai/lego";
import classes from "../summary.module.scss";
import CostBreakdown from "./CostBreakdown";
import SavingsBreakdown from "./SavingsBreakdown";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { ClockBlackIcon } from "@/assets/icons";
import { useAppState } from "@/modules/app/useAppContext";
import {
  DatabricksCostFutureView,
  DatabricksSavingsSection,
} from "@/pages/databricks/summary/components";

const FutureTimeRanges = [
  // "Next 1 month",
  // "Next 3 months",
  "This year",
  // "End-of-contract",
];

const FutureAnalysis = () => {
  const { isDatabricksTenant } = useAppState();

  const currentStartDate = useMemo(() => {
    const currentDate = dayjs();
    const isBeforeApril = new Date().getMonth() < 3;
    return isBeforeApril
      ? currentDate.subtract(3, "month").toDate()
      : currentDate.startOf("year").toDate();
  }, []);

  const [currentEndDate, setCurrentEndDate] = useState<Date | null>(dayjs().endOf("year").toDate());
  const [selectedTimerange, setAggregateBy] = useState(FutureTimeRanges[0]);

  const handleItemClick = (value: string) => {
    setAggregateBy(value);
    switch (value) {
      case "Next 1 month":
        setCurrentEndDate(dayjs().add(1, "month").toDate());
        break;
      case "Next 3 months":
        setCurrentEndDate(dayjs().add(3, "month").toDate());
        break;
      case "This year":
        setCurrentEndDate(dayjs().endOf("year").toDate());
        break;
      case "End-of-contract":
        setCurrentEndDate(null);
        break;
      default:
        break;
    }
  };

  const caption = isDatabricksTenant
    ? "This section shows your projected Databricks costs for the specified time period. Projections are based on recent usage trends."
    : "This section shows your projected costs and savings for the specified time period";

  return (
    <Card className={classes.past_analysis} id="future">
      <Stack className="al-justify-between mb-2">
        <Typography variant="section-heading">Future State</Typography>
        <NativeSelect
          variant="ghost"
          placeholder={selectedTimerange}
          icon={<ClockBlackIcon />}
          options={FutureTimeRanges.map(value => ({
            label: value,
            value,
          }))}
          onChange={handleItemClick}
        />
      </Stack>
      <p className={classes.caption}>{caption}</p>

      {isDatabricksTenant ? (
        <>
          <DatabricksCostFutureView startDate={currentStartDate} endDate={currentEndDate} />
          <DatabricksSavingsSection
            isFuture
            startDate={currentStartDate}
            endDate={currentEndDate}
          />
        </>
      ) : (
        <>
          <CostBreakdown
            isFuture
            currentEndDate={currentEndDate}
            currentStartDate={currentStartDate}
          />
          <SavingsBreakdown
            isFuture
            currentEndDate={currentEndDate}
            currentStartDate={currentStartDate}
          />
        </>
      )}
    </Card>
  );
};

export default FutureAnalysis;
